import { CellPosition, SelectedArea } from "./EditableTableContext";

export const doesSelectedAreaContainOnlyOneCell = (
    selectedArea: SelectedArea,
) =>
    selectedArea.topLeftCellPosition.rowIndex ===
        selectedArea.bottomRightCellPosition.rowIndex &&
    selectedArea.topLeftCellPosition.columnIndex ===
        selectedArea.bottomRightCellPosition.columnIndex;

export const isSamePosition = (a: CellPosition, b: CellPosition) =>
    a.rowIndex === b.rowIndex && a.columnIndex === b.columnIndex;
